import React from 'react';
import PropTypes from 'prop-types';
import { SuiTab } from '@splashthat/sui';

import stockImageNavLabels from '../../constants/stockImageNavLabels';

import { NavBar } from './StockSlide.styles';

export default function StockNavBar({ qaId, stockImageNavValue, updateNavValue }) {
    return (
        <NavBar className={`${qaId}_nav-wrapper`}>
            {stockImageNavLabels.map((label) => (
                <SuiTab
                    key={label}
                    isActive={stockImageNavValue === label}
                    label={label}
                    value={label}
                    orientation="vertical"
                    onActive={(_, value) => updateNavValue(value)}
                />
            ))}
        </NavBar>
    );
}

StockNavBar.propTypes = {
    qaId: PropTypes.string,
    stockImageNavValue: PropTypes.string.isRequired,
    updateNavValue: PropTypes.func.isRequired,
};

StockNavBar.defaultProps = {
    qaId: 'StockNavBar',
};
